import React, { useEffect, useRef, useState } from "react";
import { Alert, Container, FormGroup, InputGroup, Spinner } from "reactstrap";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { showTopbarInsideAction } from "../../store/actions";
import HeaderDefaultToPage from "../../components/Common/headerDefaultToPage";
import { ContainerBoxItem } from "../../components/Common/Search";

import { Skeleton } from "primereact/skeleton";
import BizinBackend from "../../helpers/bizin_helper";
import NotFound from "../../components/Common/notFound";
import withRouter from "../../components/Common/withRouter";
import useGetCsrfToken from "../../Hooks/useGetCsrfToken";

const menusDefault = [
  {
    name: "Pedido",
    sigla: "PED",
    id: 1,
  },
  {
    name: "Nota Fiscal",
    sigla: "NFE",
    id: 2,
  },
  {
    name: "Doc Transp",
    sigla: "CTE",
    id: 3,
  },
   {
    name: "Pré-Agenda",
    sigla: "PRE",
    id: 9,
  },
  {
    name: "Agendamento",
    sigla: "AGE",
    id: 4,
  },
  {
    name: "Mensagem",
    sigla: "MSG",
    id: 7,
  },
  {
    name: "Transação",
    sigla: "TRA",
    id: 8,
  },
];

const BI_WS0001 = (props) => {
  document.title = "Defender | Busca";

  const dispatch = useDispatch();

  const { search } = useLocation();

  const { userProfile, accessTokenMsman } = useSelector((state) => ({
    userProfile: state.login.profile,
    accessTokenMsman: state.login.user.access_token
  }));

  const csrfToken = useGetCsrfToken();
  const [menu, setMenu] = useState([]);
  const [disabledLoadMore, setdisabledLoadMore] = useState(false);
  const [contentMenu, setContentMenu] = useState([]);
  const [contentMenuFiltered, setContentMenuFiltered] = useState([]);
  const [noContentMenu, setnoContentMenu] = useState(true);
  const [loading, setloading] = useState(false);
  const [loadingLoadMore, setloadingLoadMore] = useState(false);
  const [loadingByFilter, setloadingByFilter] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const dateToRef = useRef(null);
  const dateFromRef = useRef(null);
  const [messageErrorFilter, setmessageErrorFilter] = useState(null);
  const [messageError, setmessageError] = useState(null);
  const [triggerFilter, setTriggerFilter] = useState(false);
  const [preFilterSelected, setpreFilterSelected] = useState(null);

  const stateInitialFilters = {
    2: new URLSearchParams(search).get("filter"), //Texto_Busca
    3: null, //Data_Inical
    4: null, //Data_Final
    5: "pt-BR", //Cultura_Idioma
    6: null, //ID_Objeto
    7: 0, //Pagina
  };

  const [filtersParams, setfilterParams] = useState(stateInitialFilters);

  const handleContentMenuFilter = (id) => {
    setmessageError(null);
    let filter = [];

    if (filtersParams[6] !== id) {
      filter = [contentMenu[id]];   
      setfilterParams((state) => ({ ...state, 6: id }));
      setContentMenuFiltered(filter);
    }
  };

  const handleLoadMore = () => {
    setfilterParams((state) => ({ ...state, 7: filtersParams[7] + 1 }));
  };

  const resetStates = () => {
    setContentMenuFiltered([]);
    setdisabledLoadMore(false);
    setfilterParams((state) => ({ ...state, 6: null, 7: 0 }));
  };

  const handleSearch = async () => {
    let input = new URLSearchParams(search).get("filter");
    setfilterParams((state) => ({ ...state, 2: input }));
    setmessageError(null);
    setmessageErrorFilter(null);
    setTriggerFilter(false);

    try {
      const data = await BizinBackend.executeProcedure(
        {
            1: userProfile?.ID_Usuario, // ID_Usuario
            2: "pt-BR", // Cultura_Idioma
            3: input, // Texto_Busca
            4: filtersParams[3] || new Date(new Date().setDate(-29)).toLocaleDateString(), // Data_Inical
            5: !filtersParams[3] ? new Date(new Date()).toLocaleDateString() : filtersParams[4], // Data_Final
            6: filtersParams[6], // ID_Objeto
            7: 0, // Pagina
            8: filtersParams[7] ? 10 * filtersParams[7] : 10, // Registros_Pagina
          },
          "FRONT_Workspace_BI_WS0001",
          csrfToken,
          accessTokenMsman
      )

      if (!data?.resultset_1?.length && !data?.resultset_2?.length) {
        setnoContentMenu(true);
        setContentMenu([]);
        setMenu([]);
        setContentMenuFiltered([]);
      } else {
        let total = data?.resultset_3[0]["Total_Registros"];
        let totaPages = data?.resultset_3[0]["Total_Paginas"];
        setdisabledLoadMore(filtersParams[7] >= totaPages);
        if (filtersParams[7] && total >= 1 && contentMenuFiltered?.length) {
          let updateContentMenu = contentMenu;
          updateContentMenu[data?.resultset_1[0]["ID_Objeto"]] = [
            ...data?.resultset_1,
          ];
          setContentMenu(updateContentMenu);
          setContentMenuFiltered([
            updateContentMenu[data?.resultset_1[0]["ID_Objeto"]],
          ]);
        } else {
          setnoContentMenu(false);
          setMenu(data.resultset_2);
          setContentMenu(
            Object.groupBy(data.resultset_1, ({ ID_Objeto }) => ID_Objeto)
          );
        }
      }
    } catch (error) {
      setmessageError("Erro ao buscar informações.");
      console.log(error);
    } finally {
      setloading(false);
      setloadingLoadMore(false);
      setOpenFilter(false);
      setloadingByFilter(false);
    }
  };

  const handleFilter = (e, preFilter = null) => {
    e.preventDefault();
    let currentDate = new Date().toLocaleDateString();

    setpreFilterSelected(preFilter);    

    switch (preFilter) {
      case "current":
        setfilterParams((state) => ({
          ...state,
          3: currentDate,
          4: currentDate,
          6: null
        }));
        break;
      case "lastWeek":
        const lastWeek = new Date();
        lastWeek.setDate(lastWeek.getDate() - 7);
        setfilterParams((state) => ({
          ...state,
          3: lastWeek.toLocaleDateString(),
          4: currentDate,
          6: null
        }));
        break;
      case "lastMonth":
        const lastMonth = new Date();
        lastMonth.setMonth(lastMonth.getMonth() - 1);
        setfilterParams((state) => ({
          ...state,
          3: lastMonth.toLocaleDateString(),
          4: currentDate,
          6: null
        }));
        break;
      case "all":
        const all = new Date();
        all.setMonth(all.getMonth() - 24);
        setfilterParams((state) => ({
          ...state,
          3: all.toLocaleDateString(),
          4: currentDate,
          6: null
        }));
        break;
      default:
        if (dateToRef.current.value === "") {
          setmessageErrorFilter("Preencha o campo 'De'.");
          return;
        } else if (dateFromRef.current.value === "") {
          setmessageErrorFilter("Preencha o campo 'Até'.");
          return;
        }
        setfilterParams((state) => ({
          ...state,
          3: dateToRef.current.value.split("-").reverse().join("/"),
          4: dateFromRef.current.value.split("-").reverse().join("/"),
          6: null
        }))
    }

    setContentMenuFiltered([]);
    setloadingByFilter(true);
    setTriggerFilter(true);
  };

  useEffect(() => {
    if (search && stateInitialFilters[2]?.length) {
        resetStates();
        setTriggerFilter(true);
    }
  }, [search]);

  useEffect(() => {
    if (triggerFilter) {
      if(!loadingLoadMore) setloading(true);
      handleSearch();
    }
  }, [triggerFilter]);

  useEffect(() => {
    if (filtersParams[7] > 0) {
      setloadingLoadMore(true);
      setTriggerFilter(true);
    }
  }, [filtersParams[7]]);

  useEffect(() => {
    setdisabledLoadMore((contentMenu[filtersParams[6]]?.length <= 2));
  }, [filtersParams[6], loadingByFilter]);

  useEffect(() => {
    dispatch(showTopbarInsideAction({}));
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if(document.querySelector('.sidebar')){
        if(document.documentElement.scrollTop >= 100){
          document.querySelector('.sidebar').style.top = '100px';
          document.querySelector('.sidebar').style.position = 'fixed';
          document.querySelector('.sidebar').style.zIndex = 2;
          document.querySelector('.container-rightbar').style.marginLeft = '110px';
        }else{
          document.querySelector('.sidebar').style.top = '0px';
          document.querySelector('.sidebar').style.position = 'relative';
          document.querySelector('.container-rightbar').style.marginLeft = '0px';
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    if(contentMenuFiltered.length) handleScroll();
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  if(!stateInitialFilters[2]){
    return <NotFound title={"Desculpe!"} description={"Nenhum resultado pode ser encontrado."} subDescription={"Tente verificar a ortografia ou usar outros termos"} goBack={() => props.router.navigate(-1)}/>
  }

  return (
    <React.Fragment>
      <div className="page-content page-search">
        <Container fluid={true} className="dataTable-custom-primary">
          <HeaderDefaultToPage title={"Busca"} goBack={false} />
          {messageError && <Alert color="danger">{messageError}</Alert>}
          <div className="d-flex content-page">
            <div className="sidebar">
                  <div className="dropdown-filter">
                    <div >
                      <a
                        type="button"
                        className={`${openFilter ? "actived" : ""} ${noContentMenu && !filtersParams[2] ? "disabled": ""}`}
                        onClick={() => noContentMenu && !filtersParams[2] ? {} : setOpenFilter(!openFilter)}
                      >
                        Data
                      </a>
                      <div
                        className={`dropdown-content-filter`}
                        style={{ display: openFilter ? "block" : "none" }}
                      >
                        <div className="pre-filters">
                          {/* <span className="header-title">Data</span> */}
                          <button
                            className={`${
                              preFilterSelected === "current" ? "font-w-bold" : ""
                            }`}
                            type="button"
                            onClick={(e) => handleFilter(e, "current")}
                          >
                            Hoje
                          </button>
                          <button
                            className={`${
                              preFilterSelected === "lastWeek" ? "font-w-bold" : ""
                            }`}
                            type="button"
                            onClick={(e) => handleFilter(e, "lastWeek")}
                          >
                            Última semana
                          </button>
                          <button
                            className={`${
                              preFilterSelected === "lastMonth" ? "font-w-bold" : ""
                            }`}
                            type="button"
                            onClick={(e) => handleFilter(e, "lastMonth")}
                          >
                            Último mês
                          </button>
                          <button
                            className={`${
                              preFilterSelected === "all" ? "font-w-bold" : ""
                            }`}
                            type="button"
                            onClick={(e) => handleFilter(e, "all")}
                          >
                            Sempre
                          </button>
                        </div>
                        <form
                          className="content-inputs"
                          onSubmit={handleFilter}
                        >
                          <FormGroup>
                            <label>De</label>
                            <InputGroup>
                              <input
                                ref={dateToRef}
                                className="form-control"
                                type="date"
                                max={
                                  typeof filtersParams[4] === "string"
                                    ? filtersParams[4]
                                    : ""
                                }
                                defaultValue={
                                  filtersParams[3] ? filtersParams[3].split("/").reverse().join("-") : new Date(new Date().setDate(-29)).toLocaleDateString().split('/').reverse().join('-')
                                }
                              />
                              <a
                                onClick={(e) => {
                                  e.preventDefault();
                                  dateToRef.current.showPicker();
                                }}
                                className="input-group-append"
                              >
                                <i class="fas fa-calendar-alt"></i>
                              </a>
                            </InputGroup>
                          </FormGroup>
                          <FormGroup>
                            <label>Até</label>
                            <InputGroup>
                              <input
                                ref={dateFromRef}
                                className="form-control"
                                type="date"
                                min={
                                  typeof filtersParams[4] === "string"
                                    ? filtersParams[4]
                                        .split("/")
                                        .reverse()
                                        .join("-")
                                    : ''
                                }
                                defaultValue={
                                  filtersParams[4]
                                    ? filtersParams[4]
                                        .split("/")
                                        .reverse()
                                        .join("-")
                                    : new Date().toLocaleDateString().split('/').reverse().join('-')
                                }
                              />
                              <a
                                onClick={(e) => {
                                  e.preventDefault();
                                  dateFromRef.current.showPicker();
                                }}
                                className="input-group-append"
                              >
                                <i class="fas fa-calendar-alt"></i>
                              </a>
                            </InputGroup>
                          </FormGroup>
                          {loadingByFilter && (
                            <div className="container-loading">
                              <Spinner color="primary" size="sm" />
                            </div>
                          )}
                          { messageErrorFilter && (
                            <Alert color="warning">{messageErrorFilter}</Alert>
                          )}
                          <div className="d-flex align-items-center footer-btn justify-content-between">
                            <button
                              type="button"
                              onClick={() => setOpenFilter(false)}
                              className={`btn border-0 text-primary-dark`}
                            >
                              Cancelar
                            </button>
                            <button type="submit" className={`btn border-0 `}>
                              Aplicar
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>                      
                  </div>
                  <button
                    onClick={resetStates}
                    className={`${
                      contentMenuFiltered.length ? "" : "actived"
                    }`}
                    type="button"
                  >
                    {" "}
                    Todas{" "}
                  </button>
                  {menusDefault.map((item) => {
                    let findMenu = menu.find((m) => m.ID_Objeto == item.id);
                    return (
                      <button
                        onClick={() =>
                          handleContentMenuFilter(item.id)
                        }
                        className={`${
                          filtersParams[6] == item.id
                            ? "actived"
                            : ""
                        } ${findMenu ? "" : "disabled"}`}
                        type="button"
                        key={item.id}
                        id={item.id}
                      >
                        {item?.name}
                        {findMenu && <span className="dot">{findMenu?.Total_Registros_Filtrados > 99 ? "99+" : findMenu?.Total_Registros_Filtrados || 0}</span>}
                      </button>
                  )})}
                  {/* {menu.length ? (
                    <>
                      {menu.map((item) => (
                        <button
                          onClick={() =>
                            handleContentMenuFilter(item.ID_Objeto)
                          }
                          className={`${
                            filtersParams[6] == item.ID_Objeto
                              ? "actived"
                              : ""
                          }`}
                          type="button"
                          key={item.ID_Objeto}
                          id={item.ID_Objeto}
                        >
                          {item?.Descricao_Resumida_Objeto}
                        </button>
                      ))}
                    </>
                  ) : (
                    <></>
                  )} */}                  
            </div>
            <div className="container-rightbar">
              <div className="row container-filters-applied rightbar mt-1 mb-4">
                <div className="col d-flex align-items-center gap-2 p-0">
                  <span className="label">Filtros aplicados:</span>
                  {filtersParams[2] && (
                    <button
                      type="button"
                      className="btn d-flex align-items-center"
                    >
                      <span>Busca: {filtersParams[2]}</span>
                    </button>
                  )}
                  {filtersParams[6] && menu.filter( (i) => i.ID_Objeto === filtersParams[6] )[0]?.Descricao_Objeto && (
                    <button
                      type="button"
                      onClick={resetStates}
                      className="btn d-flex align-items-center"
                    >
                      <span>
                        {
                          menu.filter( (i) => i.ID_Objeto === filtersParams[6] )[0]?.Descricao_Objeto
                        }
                      </span>
                      <i className="mdi mdi-close"></i>
                    </button>
                  )}
                  <button
                    type="button"                    
                    className="btn d-flex align-items-center"
                  >
                    <span>
                      {filtersParams[3] || new Date(new Date().setDate(-29)).toLocaleDateString()} a {filtersParams[4] || new Date().toLocaleDateString() }
                    </span>
                    {filtersParams[3] || filtersParams[4] ? <i onClick={(e) => {
                      e.preventDefault();
                      setfilterParams((state) => ({
                        ...state,
                        3: null,
                        4: null,
                        6: null
                      }));
                      setpreFilterSelected(state => ({...state, 3: null, 4: null, 6: null}));
                      setContentMenuFiltered([]);
                      setTriggerFilter(true);
                    }} className="mdi mdi-close"></i> : null}
                  </button>
                </div>
              </div>
              {!loading && !loadingByFilter ? (
                <>
                  {contentMenuFiltered.length && !noContentMenu ? (
                    <>
                      {Object.values(contentMenuFiltered).map((contents, k) => (
                        <ContainerBoxItem
                          key={k}
                          menu={menu}
                          contents={contents}
                          callbackButton={handleLoadMore}
                          isLoadingLoadMore={loadingLoadMore}
                          disabledLoadMore={disabledLoadMore}
                          isFiltered={true}
                        />
                      ))}
                    </>
                  ) : (
                    <>
                      {Object.values(contentMenu).map((contents, k) => (
                        <ContainerBoxItem
                          key={k}
                          menu={menu}
                          isLoadingLoadMore={loadingLoadMore}
                          contents={contents}
                          callbackButton={(id) => {
                            if (!filtersParams[6]) handleContentMenuFilter(id);
                          }}
                        />
                      ))}
                    </>
                  )}

                  {noContentMenu && (
                    <div className="no-content rightbar">
                      <h6>Nenhum resultado encontrado</h6>
                      <p>
                        Não foi possível encontrar{" "}
                        <strong>nenhum resultado</strong> correspondente a{" "}
                        <strong>"{filtersParams[2]}"</strong>
                      </p>
                    </div>
                  )}
                </>
              ) : (
                <div className="mx-4">
                  <Skeleton height={30} className="mb-2" width={150} />
                  <Skeleton height={165} className="mb-2" width="940px" />
                  <Skeleton height={165} className="mb-2" width="940px" />
                  <Skeleton height={165} className="mb-2" width="940px" />
                  <Skeleton height={22} width="75px" />
                </div>
              )}
            </div>
            <div onClick={() => setOpenFilter(false)} style={{ display: openFilter ? "block" : "none" }} className="overlay"></div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(BI_WS0001);
